import { c as _c } from "react/compiler-runtime";
import Box from '@classify/react-core-components/Box';
import { styled, useTheme } from '@classify/react-core-components/styles';
const Root = styled(Box)(/* istanbul ignore next */({
  theme: {
    breakpoints
  }
}) => ({
  position: 'absolute',
  right: 0,
  bottom: 0,
  zIndex: 0,
  height: '100%',
  width: '50%',
  [breakpoints.up('sm')]: {
    width: '50%'
  }
}));
const TriangleSVG = styled('svg')(({
  theme: {
    palette,
    transitions
  }
}) => ({
  fill: ({
    color
  }) => color || palette.primary.main,
  height: '100%',
  width: '100%',
  transition: transitions.create('fill', {
    duration: transitions.duration.standard
  })
}));
export default function TriangleBackgroundContainer(t0) {
  const $ = _c(18);
  const {
    sx: t1,
    color: t2,
    withFullWidthResponsive: t3,
    isHorizontallyFlipped: t4,
    isFullyOpaque: t5
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const sx = t6;
  const color = t2 === undefined ? "" : t2;
  const withFullWidthResponsive = t3 === undefined ? false : t3;
  const isHorizontallyFlipped = t4 === undefined ? false : t4;
  const isFullyOpaque = t5 === undefined ? false : t5;
  const {
    palette
  } = useTheme();
  const points = isHorizontallyFlipped ? "100,100 0,100 0,0" : "100,100 100,0 0,100";
  const t7 = withFullWidthResponsive ? "100%" : "50%";
  let t8;
  if ($[2] !== t7) {
    t8 = {
      xs: t7,
      sm: "50%"
    };
    $[2] = t7;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  let t9;
  if ($[4] !== sx || $[5] !== t8) {
    t9 = {
      width: t8,
      ...sx
    };
    $[4] = sx;
    $[5] = t8;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  const t10 = isFullyOpaque ? 1 : 0.08;
  const t11 = color || palette.primary.main;
  let t12;
  if ($[7] !== t10 || $[8] !== t11) {
    t12 = {
      opacity: t10,
      fill: t11
    };
    $[7] = t10;
    $[8] = t11;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  let t13;
  if ($[10] !== points) {
    t13 = <polygon points={points} />;
    $[10] = points;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  let t14;
  if ($[12] !== t12 || $[13] !== t13) {
    t14 = <TriangleSVG aria-hidden="true" viewBox="0 0 100 100" preserveAspectRatio="none" style={t12}>{t13}</TriangleSVG>;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] !== t14 || $[16] !== t9) {
    t15 = <Root sx={t9}>{t14}</Root>;
    $[15] = t14;
    $[16] = t9;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  return t15;
}